import en from './en';
import ar from './ar';
import { Locales } from '@shared/models/locales.model';

export default {
  modulePrefix: 'bidChat',
  phrasesPerLang: {
    en,
    ar,
  },
} as Locales;
